export const maxDailyWorkTimeHours = 16;
